"use strict";const i=require("styled-components").css`
    &.DXItemsGrid {
        position: relative;
        width: 100%;
        display: ${({scrollable:i})=>i&&"flex"};
        flex-wrap: ${({scrollable:i})=>i&&"wrap"};
        align-items: ${({scrollable:i})=>i&&"center"};

        .DXItemsGrid-header {
            display: grid;
            grid-row-gap: 4px;
            margin-bottom: 20px;

            @media (min-width: 1024px) {
                margin-left: ${({scrollable:i})=>i&&"50px"};
            }

            .DXTypography {
                margin: 0;
            }
        }

        .DXItemsGrid-scrollableGrid {
            margin: auto;
            display: grid;
            grid-template-columns: 33px 1fr 33px;
            align-items: center;
            width: 100%;

            .DXItemsGrid-scrollBtn {
                display: none;
                cursor: pointer;
                background: transparent;
                border: none;
                padding: 0;
                margin: 0;

                > * {
                    transition: opacity 0.2s ease-in-out;
                }

                @media (min-width: 1024px) {
                    display: block;
                }

                &.inactive {
                    > * {
                        opacity: 0;
                        cursor: default;
                    }
                }
            }

            .DXItemsGrid-scrollableGrid_items {
                overflow: scroll;
                display: grid;
                grid-auto-flow: column;
                gap: 1rem;
                margin: unset;
                grid-auto-columns: calc(85% - 0.5rem);
                grid-column-start: 1;
                grid-column-end: 4;
                scroll-snap-type: x mandatory;
                overflow-x: scroll;
                overflow-y: hidden;
                scrollbar-width: none;
                -ms-overflow-style: none;
                padding: 0;
                list-style: none;

                &::-webkit-scrollbar {
                    display: none;
                }

                @media (min-width: 768px) {
                    grid-auto-columns: calc(45% - 0.5rem);
                }

                @media (min-width: 1024px) {
                    grid-auto-columns: calc(50% - 0.5rem);
                    grid-column-start: 2;
                    grid-column-end: 3;
                }

                @media (min-width: 1440px) {
                    grid-auto-columns: calc(33% - 0.5rem);
                }

                .DXModelCard-top-details {
                    div {
                        width: unset;
                    }
                }

                .slide {
                    width: 100%;
                    scroll-snap-align: start;

                    > * {
                        padding: 0;
                        width: 100%;
                    }

                    .DXModelCard {
                        width: 100%;
                    }

                    .DXModelCard-top {
                        width: 100%;
                    }
                }
            }
        }

        .DXItemsGrid-headings-group {
            display: grid;
        }
    }
`;module.exports=i;
//# sourceMappingURL=styles.js.map
